            this.prevButton = document.querySelector(".prev-next-button--prev"),
            this.nextButton = document.querySelector(".prev-next-button--next"),
            this.prevButton.addEventListener("click", () => this.prevButton.dispatchEvent(new CustomEvent("prev-next:prev",{
                bubbles: !0
            }))),
            this.nextButton.addEventListener("click", () => this.nextButton.dispatchEvent(new CustomEvent("prev-next:next",{
                bubbles: !0
            })))


function getSiblings(element, filter, includeSelf = false) {
    let siblings = [];
    let currentElement = element;
    while (currentElement = currentElement.previousElementSibling) {
      if (!filter || currentElement.matches(filter)) {
        siblings.push(currentElement);
      }
    }
    if (includeSelf) {
      siblings.push(element);
    }
    currentElement = element;
    while (currentElement = currentElement.nextElementSibling) {
      if (!filter || currentElement.matches(filter)) {
        siblings.push(currentElement);
      }
    }
    return siblings;
  }

        var Timeline = class extends HTMLElement {
        connectedCallback() {
            if (this.prevNextButtons = this.querySelector("prev-next-buttons"),
            this.scrollBarElement = this.querySelector(".timeline__progress-bar"),
            this.listWrapperElement = this.querySelector(".timeline__list-wrapper"),
            this.listItemElements = Array.from(this.querySelectorAll(".timeline__item")),
            this.isScrolling = !1,
            this.listItemElements.length > 1) {
                this.addEventListener("prev-next:prev", this.previous.bind(this)),
                this.addEventListener("prev-next:next", this.next.bind(this)),
                this.addEventListener("page-dots:changed", event => this.select(event.detail.index)),
                window.Shopify?.designMode && this.addEventListener("shopify:block:select", event => {
                    this.select([...event.target.parentNode.children].indexOf(event.target), !event.detail.load)
                }
                ),
                this.itemIntersectionObserver = new IntersectionObserver(this._onItemObserved.bind(this),{
                    threshold: .4
                });
                const mediaQuery = window.matchMedia("screen and (max-width: 100px)");
                mediaQuery.addListener(this._onMediaChanged.bind(this)),
                this._onMediaChanged(mediaQuery)
            }
        }
        get selectedIndex() {
            return this.listItemElements.findIndex(item => !item.hasAttribute("hidden"))
        }
        previous() {
            this.select(Math.max(0, this.selectedIndex - 1))
        }
        next() {
            this.select(Math.min(this.selectedIndex + 1, this.listItemElements.length - 1))
        }
        select(index, animate=!0) {
            const listItemElement = this.listItemElements[index]
              , boundingRect = listItemElement.getBoundingClientRect();
            animate && (this.isScrolling = !0,
            setTimeout( () => this.isScrolling = !1, 800)),
            window.matchMedia("screen and (max-width: 100px)").matches ? this.listWrapperElement.scrollTo({
                behavior: animate ? "smooth" : "auto",
                left: this.listItemElements[0].clientWidth * index
            }) : this.listWrapperElement.scrollBy({
                behavior: animate ? "smooth" : "auto",
                left: Math.floor(boundingRect.left - window.innerWidth / 2 + boundingRect.width / 2)
            }),
            this._onItemSelected(index)
        }
        _onItemSelected(index) {
            var _a;
            const listItemElement = this.listItemElements[index];
            listItemElement.removeAttribute("hidden", "false"),
            getSiblings(listItemElement).forEach(item => item.setAttribute("hidden", "")),
            this.prevNextButtons.isPrevDisabled = index === 0,
            this.prevNextButtons.isNextDisabled = index === this.listItemElements.length - 1,
            (_a = this.scrollBarElement) == null || _a.style.setProperty("--transform", `${100 / (this.listItemElements.length - 1) * index}%`)
        }
        _onItemObserved(entries) {
            this.isScrolling || entries.forEach(entry => {
                entry.isIntersecting && this._onItemSelected([...entry.target.parentNode.children].indexOf(entry.target))
            }
            )
        }
        _onMediaChanged(event) {
            event.matches ? this.listItemElements.forEach(item => this.itemIntersectionObserver.observe(item)) : this.listItemElements.forEach(item => this.itemIntersectionObserver.unobserve(item))
        }
    }
    ;
    window.customElements.define("time-line", Timeline);